module.exports = __webpack_public_path__ + "media/images/user-avatar-e2c2e99d48506986afd744382008d8ff.svg";